<template>
    <div class="printManagementListClass" v-loading="loading">
        <div class="searchPart">
            <el-input v-model="productDisplayValue" placeholder="成品名称"></el-input>
            <el-button class="searchBtn" @click="getList">搜索</el-button>
        </div>
        <div class="tablePart">
            <div class="tableTool">
                <div class="toolLeft">
                    <span>已选： <span class="num">{{multipleSelection.length}}</span></span>
                    <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0" @click="del('all')">批量删除</el-button>
                    <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0" @click="publish('all')">批量发布</el-button>
                </div>
                <div class="toolRight">
                    <el-button type="primary" size="small" @click="toDialog('add')"><i class="el-icon-circle-plus-outline"></i>添加</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%" @selection-change="handleSelectionChange" class="tableContent">
                <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="成品缩略图"
                    header-align="center"
                    align="center"
                    width="250">
                    <template slot-scope="scope">
                        <img :src="scope.row.urlList[0].urlPath" alt="" v-if="scope.row.urlList[0]">
                    </template>
                </el-table-column>
                <el-table-column
                    prop="productName"
                    label="成品名称"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="isIssue"
                    label="状态"
                    header-align="center"
                    align="center">
                    <template slot-scope="scope">
                        {{scope.row.isIssue === 1?'已发布': '未发布'}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="排序"
                    header-align="center"
                    align="center">
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="scope.row.isIssue !== 1" @click="publish(scope.row.uuid)">发布</el-button>
                        <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                        <el-button type="text" size="small" @click="del(scope.row.uuid)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total,prev, pager, next,jumper"
                :page-size="10"
                :total="1000" class="pagination">
            </el-pagination>
        </div>
        <product-display-dialog  ref="dialogRef" @submit="init"></product-display-dialog>
    </div>
</template>

<script>
    import productDisplayDialog from './productDisplayDialog'
    import {
        getPresentationList,
        delPresentationList,
        publishPresentation
    } from "../../../utils/interface";
    export default {
        data(){
            return{
                loading: '',
                productDisplayValue: '',
                tableData: [],
                multipleSelection: []
            }
        },
        components: {
            productDisplayDialog
        },
        mounted() {
            this.init()
        },
        methods: {
            init(){
                this.productDisplayValue = ''
                this.getList()
            },
            // 清除检索条件
            reset(){
                this.serveTypeValue = ''
                this.serveNameValue = ''
            },
            // 复选框选中值
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            // 编辑/新增
            toDialog(type,id){
                this.$refs.dialogRef.init(type,id)
            },
            // 获取列表
            getList(){
                this.loading = true
                getPresentationList({productName:this.productDisplayValue}).then((res)=>{
                    if(res){
                        this.tableData = res
                    }
                    this.loading = false
                })
            },
            // 删除
            del(val){
                let ids = ''
                if(val === 'all'){
                    ids = this.multipleSelection.map((item)=>{
                        return item.uuid
                    }).toString()
                } else {
                    ids = val
                }
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    delPresentationList({ids:ids}).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: res.message
                            });
                            this.init()
                        } else {
                            this.$message({
                                type: 'waring',
                                message: res.message
                            });
                        }
                        this.loading = false
                    })
                }).catch(() => {})
            },
            // 发布
            publish(val){
                let ids = ''
                if(val === 'all'){
                    ids = this.multipleSelection.map((item)=>{
                        return item.isIssue !== 1 ?item.uuid:''
                    }).toString()
                } else {
                    ids = val
                }
                console.log(ids)
                this.$confirm('确定要发布吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    publishPresentation({ids:ids}).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: res.message
                            });
                            this.init()
                        } else {
                            this.$message({
                                type: 'waring',
                                message: res.message
                            });
                        }
                        this.loading = false
                    })
                }).catch(() => {})
            }
        }
    }
</script>

<style scoped lang="less">
    .printManagementListClass{
        padding: 20px;
        .searchPart {
            display: flex;
            flex-wrap: wrap;
            
            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }
            
            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                
                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }
            
            /deep/ .el-input__prefix {
                top: -3px;
            }
            
            /deep/ .el-input__suffix {
                top: 2px;
            }
            
            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }
            
            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }
            
            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }
        .tablePart{
            .tableTool{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                .toolLeft{
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.847);
                    .num{
                        color: #356FDF;
                    }
                    button{
                        padding: 0;
                        margin-left: 15px;
                        width: 80px;
                        height: 30px;
                        background: rgba(242, 244, 247, 1);
                        box-sizing: border-box;
                        border: 1px solid rgba(21, 126, 251, 1);
                        border-radius: 5px;
                        font-size: 12px;
                        color: #157EFB;
                        line-height: 30px;
                        text-align: center;
                        &:hover{
                            background:#157EFB;
                            box-sizing: border-box;
                            border: 1px solid #157EFB;
                            color: #fff;
                        }
                    }
                }
                .toolRight{
                    button{
                        width: 83px;
                        height: 30px;
                        background: rgba(21, 126, 251, 1);
                        border: none;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #fff;
                        i{
                            padding-right: 5px;
                        }
                        &:hover{
                            background: #61a2f0;
                        }
                    }
                }
            }
            .tableContent{
                min-height: 650px;
                /deep/.el-table__header{
                    tr{
                        th{
                            border-right: none;
                        }
                    }
                    /deep/.el-table__cell{
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }
                /deep/.el-table__body{
                    img{
                        vertical-align: middle;
                        width: 110px;
                        height: 64px;
                    }
                    /deep/.el-table__row{
                        td:first-child{
                            border-right: none;
                            .cell{
                                padding-left: 15px;
                            }
                        }
                    }
                }
            }
            .pagination{
                margin-top: 20px;
                text-align: right;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commodity/printManagement/productDisplay.vue